import { useEffect, useState } from "react";

import { isValidNumericParam } from "@/shared/utils/common.utils";
import { InviteHttpService } from "@/modules/assessments/services/invite-http.service";

export interface ITestSectionLog {
  testId: number;
  testName: string;
  sections: ISectionLog[];
}

interface ISectionLog {
  name: string;
  timeLimit: number;
  timeSpent: number;
}

export default function useGetAssessmentInviteTestSectionLogsHook(inviteId: number): {
  testSectionLogs: ITestSectionLog[];
  isLoading: boolean;
} {
  const [testSectionLogs, setTestSectionLogs] = useState<ITestSectionLog[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchTestSectionLogs = async () => {
      try {
        if (inviteId) {
          setIsLoading(true);
          const logs = await InviteHttpService.getTestSectionLogs(inviteId);
          setTestSectionLogs(logs);
        }
      } catch (e: any) {
        console.error(`testSectionLogs error, ${e}`);
      } finally {
        setIsLoading(false);
      }
    };
    if (isValidNumericParam(inviteId)) {
      fetchTestSectionLogs();
    }
  }, [inviteId]);

  return {
    testSectionLogs,
    isLoading,
  };
}
